import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || 'sin numero';
  const storeName = process.env.REACT_APP_STORE_NAME || 'Tu Tienda';
  const storeEmail = process.env.REACT_APP_STORE_EMAIL || 'info@tienda.com';
  const storeHours = process.env.REACT_APP_STORE_HOURS || 'Lun - Vie: 9:00 - 18:00';
  const storeLogo = process.env.REACT_APP_STORE_LOGO_URL;

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Columna 1: Logo y Sobre Nosotros */}
        <div className="footer-column footer-column-about">
          {storeLogo && (
            <img 
              src={storeLogo} 
              alt={storeName} 
              className="footer-logo"
              style={{ height: '80px', width: 'auto', objectFit: 'contain', marginBottom: '1.5rem' }}
            />
          )}
          <h3 className="footer-title">Sobre Nosotros</h3>
          <p className="footer-description">
            Tu tienda de confianza para encontrar los mejores productos al mejor precio. 
            Atención personalizada por WhatsApp.
          </p>
          <a 
            href={`https://wa.me/${whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-whatsapp-btn"
          >
            <span>💬</span>
            Contactar por WhatsApp
          </a>
        </div>

        {/* Columna 2: Enlaces rápidos */}
        <div className="footer-column">
          <h3 className="footer-title">Enlaces Rápidos</h3>
          <ul className="footer-links">
            <li>
              <Link to="/">Inicio</Link>
            </li>
            <li>
              <Link to="/catalogo">Catálogo</Link>
            </li>
            <li>
              <a 
                href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Hola! Me gustaría saber sobre sus productos.')}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Consultar Productos
              </a>
            </li>
            <li>
              <a 
                href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Hola! Necesito ayuda con mi pedido.')}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Ayuda
              </a>
            </li>
          </ul>
        </div>

        {/* Columna 3: Información de contacto */}
        <div className="footer-column">
          <h3 className="footer-title">Contacto</h3>
          <ul className="footer-contact">
            <li>
              <span className="contact-icon">📱</span>
              <a 
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp
              </a>
            </li>
            <li>
              <span className="contact-icon">📧</span>
              <span>{storeEmail}</span>
            </li>
            <li>
              <span className="contact-icon">⏰</span>
              <span>{storeHours}</span>
            </li>
          </ul>
        </div>

        {/* Columna 4: Métodos de pago */}
        <div className="footer-column">
          <h3 className="footer-title">Medios de Pago</h3>
          <p className="footer-payment-info">
            Aceptamos múltiples métodos de pago. Consulta por WhatsApp para más información.
          </p>
          <div className="footer-payment-icons">
            <span style={{ fontSize: '2rem' }}>💳</span>
            <span style={{ fontSize: '2rem' }}>💵</span>
            <span style={{ fontSize: '2rem' }}>🏦</span>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="footer-copyright">
            © {currentYear} {storeName}. Todos los derechos reservados.
          </p>
          <div className="footer-social">
            <a 
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="WhatsApp"
            >
              💬
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

